class HelpWidgetComponent {
  constructor($sce, $interval) {
    'ngInject';
    this.$sce = $sce;
    this.$interval = $interval;
  }

  async $onInit() {
  }

  loadWidget(){
    if ($('#launcher-frame').length) return;
    const widget = `
      <script> 
        window.fwSettings={ 'widget_id':${this.widgetId} };
        !function(){if("function"!=typeof window.FreshworksWidget){var n=function(){n.q.push(arguments)};n.q=[],window.FreshworksWidget=n}}() 
      </script>
      <script type='text/javascript' src='https://widget.freshworks.com/widgets/${this.widgetId}.js' async defer></script>`;
    this.adjustStyles();
    return this.widgetId? this.$sce.trustAsHtml(widget) : "";
  }

  async adjustStyles() {
    let styleLoad = this.$interval(
      () => {
        if ($('#launcher-frame').length) {
          $('#launcher-frame').css({'bottom': '0px', 'right': '6px'});
          this.$interval.cancel(styleLoad);
        }
      }, 100);
  }
}

export default {
  bindings: {
    widgetId: "<"
  },
  templateUrl: 'form-builder/help-widget/help-widget.component.html',
  controller: HelpWidgetComponent
};
